import { render, staticRenderFns } from "./ViewSwitch.vue?vue&type=template&id=e9748a70&scoped=true&"
import script from "./ViewSwitch.vue?vue&type=script&lang=js&"
export * from "./ViewSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ViewSwitch.vue?vue&type=style&index=0&id=e9748a70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9748a70",
  null
  
)

export default component.exports